import { Box, Typography } from '@mui/material'
import _ from 'lodash'
import React from 'react'
import MeruDate from 'src/legacy/lib/MeruDate'

const calculateResponsesPerWeek = (responses: Array<CompletedResponse>, programStartDate: string) => {
  if (!new MeruDate(programStartDate).valueOf()) {
    return {}
  }

  return _.chain(responses)
    .groupBy(({ date }) => {
      // MeruDate normalizes to the UTC calendar date first. No timezone arg is needed - the week number is a diff of two
      // calendar dates, so any timezone offset applies to both sides and cancels out.
      const weekNumber = new MeruDate(date).formatWeekNumber(programStartDate, true)
      // Responses logged before the program start still count toward week 1
      return weekNumber === null ? null : Math.max(weekNumber, 1)
    })
    .mapValues((values) => _.chain(values).map('count').sum().value())
    .value()
}

type CompletedResponse = {
  count: number
  date: Date
}

type Props = {
  lastWeekNbr?: number
  programStartDate: string
  completedResponses: Array<CompletedResponse>
}

const PracticesPerWeek: React.FC<Props> = ({ lastWeekNbr = 8, completedResponses, programStartDate }) => {
  const responsesPerWeek = calculateResponsesPerWeek(completedResponses, programStartDate)

  return (
    <Box display="flex" justifyContent="space-around">
      {_.times(lastWeekNbr).map((week) => (
        <Box display="block" textAlign="center" paddingLeft="4px" paddingRight="4px" key={week}>
          <Typography color="textSecondary" variant="caption">
            {week + 1}
          </Typography>
          <Typography color="primary" variant="h4">
            {responsesPerWeek[week + 1] >= 0 ? responsesPerWeek[week + 1] : '-'}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

export default PracticesPerWeek
